import config from 'crm/config'

const customerApi = `${config.apiHost}/oem-customer`

export default {
    // 群发列表
    getBulkList: {
        url: `${customerApi}/api/group_sending`,
        type: 'GET',
    },

    // 群发明细列表
    getBulkDetails: {
        url: `${customerApi}/api/mass_sending/{id}/details`,
        type: 'GET',
    },

    // 创建群发
    createBulk: {
        url: `${customerApi}/api/group_sending`,
        type: 'POST',
    },

    // 群发摘要
    getBulkSummary: {
        url: `${customerApi}/api/mass_sending/{id}/summary`,
        type: 'GET',
    },

    // 获取客户管理的客户
    getCustomers: {
        url: `${customerApi}/api/customers/search`,
        type: 'POST',
    },

    // 获取重发详情
    getRepeatDetails: {
        url: `${customerApi}/api/group_sending/{id}/replicator`,
        type: 'GET',
    },

    // 取消群发
    cancelSendBulk: {
        url: `${customerApi}/api/group_sending/{id}/cancel`,
        type: 'POST',
    },

    // 计算过滤后的群发客户数量
    getFilterCustomerCount: {
        url: `${customerApi}/api/mass_sending/prepare`,
        type: 'POST',
    },

    exportData: {
        url: `${customerApi}/api/group_sending/{id}/export`,
        type: 'POST',
    },
}
